import api from './api';
import type { MultiSelectOption } from '../components/MultiSelect';

export interface ManagedCardConfig {
  title: string;
  bucket?: string;
  filterConditions?: { id: number; field: string; compare: string; values: string }[];
  filterView?: string;
  includeClosed?: boolean;
  additionalFields?: string[];
  visibleColumns?: string[];
  grouping?: string[];
  tabGrouping?: string;
}
export interface ManagedCard {
  id: string;
  recipients: string[];
  config: ManagedCardConfig;
}
export interface ManagedWorkspace {
  id: number;
  name: string;
  revision: number;
  config: { recipients: string[]; cards: ManagedCard[] };
}
export const lcManagedWorkspacesService = {
  async list(): Promise<{ workspaces: ManagedWorkspace[]; recipients: MultiSelectOption[] }> {
    return (await api.get('/lc-managed-workspaces')).data;
  },
  async save(workspace: ManagedWorkspace): Promise<void> {
    await api.put(`/lc-managed-workspaces/${workspace.id}`, {
      name: workspace.name, revision: workspace.revision, ...workspace.config,
    });
  },
  async remove(workspace: ManagedWorkspace): Promise<void> {
    await api.delete(`/lc-managed-workspaces/${workspace.id}`, { params: { revision: workspace.revision } });
  },
};
